<template>
  <div class="productHome">
    <div class="home-content">
      <div class="search-container">
        <a-select class="search-select" v-model="selectedValue" placeholder="请选择">
          <a-select-option
              v-for="item in options"
              :key="item.value"
              :value="item.value"
          >
            {{ item.label }}
          </a-select-option>
        </a-select>
        <div class="search-input-wrapper">
          <a-input v-model="keyword" @pressEnter="searchBtn" class="search-input"
                   :placeholder="$t('h.custom.EnterTheContentYouNeedToSearch')"/>
          <img class="search-icon"
               src="@/assets/img/suppliersearch.png" @click="searchBtn">
        </div>
      </div>
      <div class="baseTitle home-title">
        {{ $t('h.custom.ExhibitRecommendation') }}
      </div>
      <div class="swiperBox1 home-swiper">
        <div class="icons">
          <swiper ref="mySwiper" :options="swiperOption">
            <swiper-slide v-for='item in page' :key='item.id'>
              <div v-for="(page, index) in item" :key="index" class="icons-item">
                <div class="product-card flex flex-column"
                     @click="$router.push({path: '/product/product-detail', query: {id : page.id}})">
                  <div class="product-title">{{
                      page[$language === 'ZH' ? 'titleCn' : 'titleEn']
                    }}
                  </div>
                  <img :src="page.imageUrl" class="product-img"/>
                </div>
              </div>
            </swiper-slide>
          </swiper>
          <div class="swiper-button-prev" slot="button-prev"/>
          <div class="swiper-button-next" slot="button-next"/>
        </div>
      </div>
      <div class="flex justify-center" style="margin-top: 30px;">
        <a-button
            style="width: 189px;height: 48px;background: #F0831E;border-radius: 1px;font-size: 16px;color: #FFFFFF;"
            @click="handleGoList('产品')">
          {{ $t('h.custom.SeeMore') }}
        </a-button>
      </div>
      <div style="width: 1140px;margin-top: 60px;margin-left: 12px;" class="flex">
        <div style="width: 272px;margin-right: 20px;background-color: rgba(255,255,255,0.5);overflow: hidden;">
          <img :src="coverImage" class="customImage"
               style="width: 100%;height: 546px;border-radius: 4px;cursor:pointer;" @click="loginBtn"/>
        </div>
        <div style="width: 848px;background: #FAFAFA;border-radius: 4px;height: auto;">
          <div style="font-size: 24px;color: #212121;padding: 20px 30px;">{{ $t('h.custom.BuyerPurchasingNeeds') }}</div>
          <swiper ref="mySwiper" :options="swiperOptionBuyer" style="min-height: 370px;">
            <swiper-slide v-for='item in posts' :key='item.id'>
              <div style="height: auto;padding: 0 10px;">
                <div v-for="(childItem,index) in item" :key="index">
                  <!--                  background-color: #E9EEF6;color: #131313;-->
                  <div style=" height: 54px;font-size: 14px;cursor: pointer;" class="flex"
                       :key="index" @click="handleClickProcurementRequirements(childItem.id)">
                    <div style="flex: 1" class="flex align-center justify-center">{{ childItem.postsClassify_dictText }}</div>
                    <div style="flex: 3" class="flex align-center justify-center">{{ childItem.content }}</div>
                    <div style="flex: 1" class="flex align-center justify-center">{{ childItem.createTime }}</div>
                  </div>
                </div>
              </div>
            </swiper-slide>
          </swiper>

          <div style="height: 92px;position: relative;" class="flex justify-center align-center">
            <div style="margin-top: 0;" class="swiper-pagination" slot="button-next"/>
            <div style="height: 92px;position: absolute;right: 0;padding-right: 24px;" class="flex align-center">
              <a-button class="customBtn"
                        style="width: 189px;height: 48px;background: #F0831E;border-radius: 1px;font-size: 16px;color: #FFFFFF;border: none;"
                        @click="$router.push('/product/asktobuy')">
                {{ $t('h.custom.SeeMore') }}
              </a-button>
            </div>
          </div>
        </div>
      </div>
      <div class="baseTitle"
           style="padding-top: 60px;padding-bottom: 30px;">
        {{ $t('h.custom.ExhibitorRecommendation') }}
      </div>
      <div class="swiperBox2"
           style="width: 1260px;height: auto;display: flex;justify-content: center;position: relative;">
        <div class="icons">
          <swiper ref="mySwiper" :options="swiperOption">
            <swiper-slide v-for='item in pageMerchant' :key='item.id'>
              <div v-for="page in item" :key="page.id" class="icons-item">
                <div style="width: 100%;height: 100%;cursor:pointer;"
                     @click="$router.push({path: '/product/supplier-detail', query: {id : page.id}})"
                     class="flex flex-column">
                  <div
                      style="width: 100%;height: 151px;border: 1px solid #D8D8D8;border-radius: 6px;position: relative;display: flex;justify-content: center;align-items: center;padding-bottom: 20px;">
                    <img :src="page.logoUrl" style="max-width: 100%;max-height: 100%;width: auto;height: auto;border-radius: 6px;"/>
                    <div class="flex align-center"
                         style="width: 100%;height: 32px;position: absolute;bottom: 0;background-image: linear-gradient(270deg, #FFFFFF 0%, #F0831E 100%);border-radius: 0 0 6px 6px;padding-left: 10px;font-size: 12px;color: #FFFFFF;font-weight: bold;">
                      {{ page.boothNumber }}
                    </div>
                  </div>
                  <div class="line-one" style="text-align: center;padding-top: 2px;font-size: 14px;color: #000000;height: 24px;">{{
                      page[$language === 'ZH' ? "companyNameCn" : "companyNameEn"]
                    }}
                  </div>
                </div>
              </div>
            </swiper-slide>
          </swiper>
          <div class="swiper-button-prev" slot="button-prev"/>
          <div class="swiper-button-next" slot="button-next"/>
        </div>
      </div>
      <div class="flex justify-center" style="margin-top: 30px;">
        <a-button
            style="width: 189px;height: 48px;background: #F0831E;border-radius: 1px;font-size: 16px;color: #FFFFFF;"
            @click="handleGoList('供应商')">
          {{ $t('h.custom.SeeMore') }}
        </a-button>
      </div>
      <div class="baseTitle"
           style="padding-top: 60px;padding-bottom: 30px;">
        {{ $t('h.custom.PopularVideosAndLiveBroadcasts') }}
      </div>
      <div class="swiperBox3"
           style="width: 1260px;height: auto;display: flex;justify-content: center;position: relative;">
        <div class="icons">
          <swiper ref="mySwiper" :options="swiperVideoOption">
            <swiper-slide v-for='(item, index) in videoPage' :key="index">
              <div v-for="page in item" :key="page.id" class="icons-item">
                <div style="width: 100%;height: auto;"
                     class="flex flex-column">
                  <div
                      style="width: 100%;height: 201px;border-radius: 6px;position: relative;">
                    <video :poster="page.coverImage" controls style="width: 100%;height: 100%;border-radius: 6px;"
                           @play="handlePlayVideo($event, page.id)" :ref="page.id">
                      <source
                          :src="page.videoUrl"
                          type="video/mp4">
                    </video>
                  </div>
                  <div style="margin-top: 12px;" class="flex align-center justify-between">
                    <div
                        style="font-size: 20px;color: #444444;flex: 0.9;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;"
                        :title="page[$language === 'ZH' ? 'title' : 'titleEn']">
                      {{ page[$language === 'ZH' ? 'title' : 'titleEn'] }}
                    </div>
                    <div style="font-size: 14px;color: #8D8D8D;">{{ $moment(page.createTime).format('YYYY-MM-DD') }}</div>
                  </div>
                  <div style="
                    font-size: 14px;
                    color: #444444;
                    word-break: break-all;
                    text-overflow: ellipsis;
                    overflow: hidden;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 2;"
                  >
                    {{ page[$language === 'ZH' ? 'content' : 'contentEn'] }}
                  </div>
                </div>
              </div>
            </swiper-slide>
          </swiper>
          <div class="swiper-button-prev" slot="button-prev"/>
          <div class="swiper-button-next" slot="button-next"/>
        </div>
      </div>
      <div class="flex justify-center" style="margin-top: 30px;">
        <a-button
            style="width: 189px;height: 48px;background: #F0831E;border-radius: 1px;font-size: 16px;color: #FFFFFF;"
            @click="$router.push('/product/PopularVideos')">
          {{ $t('h.custom.SeeMore') }}
        </a-button>
      </div>
    </div>
  </div>
</template>

<script>
import {Swiper, SwiperSlide} from 'vue-awesome-swiper'
import 'swiper/css/swiper.min.css'
import {getCompanyProfilesList, getEntriesList, getPostsAllList, queryVideoImgPageList, codeConfig} from "../../../assets/api";

export default {
  name: "Home",
  components: {
    Swiper,
    SwiperSlide
  },
  data() {
    return {
      keyword: "",
      selectedValue: "供应商",
      options: [
        {
          label: this.$t('h.custom.Supplier'),
          value: "供应商"
        },
        {
          label: this.$t('h.custom.Product'),
          value: "产品"
        }
      ],
      swiperOption: {
        // effect: 'flip', // 使用渐变效果
        //配置导航
        navigation: {
          nextEl: '.swiper-button-next',//下一页dom节点
          prevEl: '.swiper-button-prev'//前一页dom节点
        },
        // 循环轮播配置
        loop: false
      },
      swiperVideoOption: {
        // effect: 'flip', // 使用渐变效果
        //配置导航
        navigation: {
          nextEl: '.swiper-button-next',//下一页dom节点
          prevEl: '.swiper-button-prev'//前一页dom节点
        },
        on: {
          slideChange: this.handleSwiperVideoChange
        },
        // 循环轮播配置
        loop: false
      },
      swiperOptionBuyer: {
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        },
      },
      iconsList: [],
      listData: [
        {
          image: '@/assets/img/dynamic1.jpg',
          title: '第12届中国国际线缆及线材展览会（wire China 2026）将于2026年9月21日-24日在上海新国际博览中心举办。',
          content: '作为覆盖线缆全产业链的商贸平台，wire China 2026规模再升级，覆盖上海新国际博览中心7大展馆。wire China着力搭建线缆全产业链交流、交易平台。',
          createTime: '01-10/2026'
        },
        {
          image: '@/assets/img/dynamic2.jpg',
          title: '第12届中国国际线缆及线材展览会（wire China 2026）将于2026年9月21日-24日在上海新国际博览中心举办。',
          content: '作为覆盖线缆全产业链的商贸平台，wire China 2024规模再升级，覆盖上海新国际博览中心7大展馆。wire China着力搭建线缆全产业链交流、交易平台。',
          createTime: '01-10/2026'
        },
        {
          image: '@/assets/img/dynamic3.jpg',
          title: '第11届中国国际线缆及线材展览会（wire China 2026）将于2026年9月21日-24日在上海新国际博览中心举办。',
          content: '作为覆盖线缆全产业链的商贸平台，wire China 2024规模再升级，覆盖上海新国际博览中心7大展馆。wire China着力搭建线缆全产业链交流、交易平台。',
          createTime: '01-10/2026'
        },
        {
          image: '@/assets/img/dynamic4.jpg',
          title: '第12届中国国际线缆及线材展览会（wire China 2026）将于2026年9月21日-24日在上海新国际博览中心举办。',
          content: '作为覆盖线缆全产业链的商贸平台，wire China 2024规模再升级，覆盖上海新国际博览中心7大展馆。wire China着力搭建线缆全产业链交流、交易平台。',
          createTime: '01-10/2026'
        },
        {
          image: '@/assets/img/dynamic5.jpg',
          title: '第11届中国国际线缆及线材展览会（wire China 2026）将于2026年9月21日-24日在上海新国际博览中心举办。',
          content: '作为覆盖线缆全产业链的商贸平台，wire China 2024规模再升级，覆盖上海新国际博览中心7大展馆。wire China着力搭建线缆全产业链交流、交易平台。',
          createTime: '01-10/2026'
        }
      ],
      merchants: [],
      goods: [],
      posts: [],
      videoPlayCurrent: null,
      coverImage: null
    }
  },
  computed: {
    page() {
      let pages = [];
      this.goods.forEach((item, index) => {
        let idx = Math.floor(index / 8)
        if (!pages[idx]) pages[idx] = [];
        pages[idx].push(item)
      })
      return pages
    },
    videoPage() {
      let pages = [];
      let i = 0;
      if (this.iconsList.length) {
        this.iconsList.forEach((item, index) => {
          if (index === 0) {
            i = 0;
            pages[0] = [item]
          } else if (index === 3) {
            i = 1;
            pages[1] = [item]
          } else if (index === 6) {
            i = 2;
            pages[2] = [item]
          } else {
            pages[i].push(item)
          }
        })
      }
      return pages
    },
    pageMerchant() {
      let pages = [];
      this.merchants.forEach((item, index) => {
        let idx = Math.floor(index / 8)
        if (!pages[idx]) pages[idx] = [];
        pages[idx].push(item)
      })
      return pages
    },
  },
  created() {
    this.initConfig()
    this.loadData()
  },
  methods: {
    initConfig(){
      let imageCode = this.$language === 'ZH' ? 'POSTER_NEED_IMAGE' : 'POSTER_NEED_IMAGE_EN'
      this.$axios.get(codeConfig + imageCode).then(res=>{
        this.coverImage = res && res.data.success ? res.data.result : null
      })
    },
    handleGoList(value){
      localStorage.setItem('queryKey', value)
      this.$router.push('/product/supplier')
    },
    handleSwiperVideoChange() {
      if (this.videoPlayCurrent !== null) {
        this.videoPlayCurrent[0].pause();
        this.videoPlayCurrent = null
      }
    },
    handlePlayVideo(e, item) {
      if (this.videoPlayCurrent !== null && this.$refs[item] !== this.videoPlayCurrent) {
        this.videoPlayCurrent[0].pause();
      }
      this.videoPlayCurrent = this.$refs[item]
    },
    handleClickProcurementRequirements(id) {
      this.$router.push({
        path: "/product/asktobuy",
        query: {
          id
        }
      })
    },
    loginBtn() {
      if (localStorage.getItem('userIdentity') === 'zs') {
        this.$message.error('请先退出展商登录')
        return false
      }
      if (!localStorage.getItem('token')) {
        this.$router.push('/vistor/login')
        return false
      }
      this.$router.push('/vistor/center')
    },
    searchBtn() {
      localStorage.setItem('queryKey', this.selectedValue)
      this.$router.push('/product/supplier?search=' + this.keyword)
    },
    loadData() {
      //getEntriesList
      this.$axios.get(getCompanyProfilesList, {
        params: {
          keyword: this.keyword
        }
      }).then(res => {
        if (res.data.success) {
          this.merchants = res.data.result.records
        } else {
          this.$message.error(res.data.message)
        }
      })
      //展品
      this.$axios.get(getEntriesList, {
        params: {
          keyword: this.keyword,
          pageSize: '24'
        }
      }).then(res => {
        if (res.data.success) {
          // 过滤掉审核未通过(3)和待审核(1)的产品，只显示审核通过(2)的
          let records = res.data.result.records || [];
          records = records.filter(item => String(item.status) === '2');
          // 中文页面：过滤掉中文标题和内容都为空的产品
          if (this.$language === 'ZH') {
            records = records.filter(item => {
              const titleCn = (item.titleCn || '').trim();
              const briefCn = (item.briefCn || '').trim();
              const descriptionCn = (item.descriptionCn || '').trim();
              return titleCn || briefCn || descriptionCn;
            });
          }
          this.goods = records;
        } else {
          this.$message.error(res.data.message)
        }
      })
      //需求
      this.$axios.get(getPostsAllList, {
        params: {
          keyword: this.keyword,
          pageSize: "21"
        }
      }).then(res => {
        this.posts = [];
        if (res.data.success) {
          let posts = res.data.result.records
          if (posts.length) {
            let i = 0;
            posts.forEach((item, index) => {
              if (index === 0) {
                i = 0;
                this.posts[0] = [item]
              } else if (index === 7) {
                i = 1;
                this.posts[1] = [item]
              } else if (index === 14) {
                i = 2;
                this.posts[2] = [item]
              } else {
                this.posts[i].push(item)
              }
            })
          }
        } else {
          this.$message.error(res.data.message)
        }
      })
      this.$axios.get(queryVideoImgPageList, {
        params: {
          pageSize: '9'
        }
      }).then(res => {
        if (res.data.success) {
          this.iconsList = res.data.result.records
        } else {
          this.$message.error(res.data.message)
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
// 响应式断点
$breakpoint-md: 768px;
$breakpoint-lg: 992px;
$breakpoint-xl: 1200px;

a {
  color: #3DA5FF;
  text-decoration: none;
  transition: color 0.3s ease; /* 添加颜色过渡效果 */
}

a:hover {
  color: #F0831E;
  text-decoration: underline;
}

a:visited {
  color: #3DA5FF;
}

a:active {
  color: yellow;
}

// 产品首页容器
.productHome {
  width: 100%;
  height: auto;
  display: flex;
  justify-content: center;
  margin-top: 102px;
  padding-bottom: 100px;
}

.home-content {
  width: 100%;
  max-width: 1200px;
  height: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 30px;
  padding: 30px 16px 0;
  box-sizing: border-box;
}

// 搜索容器
.search-container {
  width: 100%;
  max-width: 800px;
  height: 58px;
  margin: 30px 0;
  display: flex;
  
  @media (max-width: #{$breakpoint-md}) {
    flex-direction: column;
    height: auto;
    
    .search-select {
      width: 100% !important;
      margin-bottom: 10px;
      
      ::v-deep .ant-select-selection {
        height: 48px;
      }
    }
    
    .search-input-wrapper {
      width: 100% !important;
    }
    
    .search-input {
      ::v-deep .ant-input {
        height: 48px !important;
      }
    }
  }
}

.search-select {
  width: 120px;
}

.search-input-wrapper {
  width: calc(100% - 120px);
  height: 100%;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
  position: relative;
}

.search-input {
  width: 100%;
  height: 100%;
  border-radius: 0;
}

.search-icon {
  width: 26px;
  height: 26px;
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
}

// 标题样式
.home-title {
  padding: 0 0 30px;
}

.baseTitle {
  font-size: 36px;
  color: #000000;
  font-weight: bold;
  position: relative;
  text-align: center;
  
  @media (max-width: #{$breakpoint-lg}) {
    font-size: 28px;
  }
  
  @media (max-width: #{$breakpoint-md}) {
    font-size: 24px;
  }
  
  &:before {
    content: '';
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 100px;
    height: 4px;
    background: #D7000F;
    border-radius: 2px;
  }
}

// Ant Design 样式覆盖
::v-deep .ant-select-selection {
  height: 58px;
  border-radius: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

::v-deep .ant-select-arrow {
  right: 20px;
}

// Swiper 通用样式
.swiperBox1,
.swiperBox2,
.swiperBox3 {
  margin-top: 30px;
  width: 100%;
  height: auto;
  display: flex;
  justify-content: center;
  position: relative;
  
  .icons {
    width: 100%;
    max-width: 1100px;
    height: auto;
    overflow: hidden;
    
    @media (max-width: #{$breakpoint-xl}) {
      max-width: 100%;
    }
  }
  
  .swiper-container {
    width: 100%;
    height: 100%;
  }
  
  .swiper-slide img {
    width: 100%;
    height: auto;
    object-fit: cover;
  }
}

// Swiper 1 样式
.swiperBox1 {
  .icons-item {
    width: 25%;
    height: auto;
    margin: auto;
    float: left;
    overflow: hidden;
    padding: 6px;
    
    @media (max-width: #{$breakpoint-lg}) {
      width: 33.3%;
    }
    
    @media (max-width: #{$breakpoint-md}) {
      width: 50%;
    }
    
    @media (max-width: 480px) {
      width: 100%;
    }
  }
}

// Swiper 2 样式
.swiperBox2 {
  .icons-item {
    width: 25%;
    height: auto;
    margin-bottom: 12px;
    float: left;
    overflow: hidden;
    padding: 6px;
    
    @media (max-width: #{$breakpoint-lg}) {
      width: 33.3%;
    }
    
    @media (max-width: #{$breakpoint-md}) {
      width: 50%;
    }
    
    @media (max-width: 480px) {
      width: 100%;
    }
  }
}

// Swiper 3 样式
.swiperBox3 {
  .icons-item {
    width: 33.3%;
    height: auto;
    margin: auto;
    float: left;
    overflow: hidden;
    padding: 6px;
    
    @media (max-width: #{$breakpoint-md}) {
      width: 50%;
    }
    
    @media (max-width: 480px) {
      width: 100%;
    }
  }
}

// 分页器样式
.swiper-pagination {
  margin-top: 20px;
  position: absolute;
  bottom: 10px;
  left: 50%;
  transform: translateX(-50%);
}

.productHome {
  ::v-deep {
    .swiper-pagination-bullet {
      width: 12px;
      height: 12px;
      margin-right: 10px;

      &.swiper-pagination-bullet-active {
        background: #F0831E;
      }
    }
  }
}

// 产品卡片样式
.product-card {
  width: 100%;
  height: 100%;
  border: 1px solid #D8D8D8;
  padding: 24px 12px;
  cursor: pointer;
  
  @media (max-width: #{$breakpoint-lg}) {
    padding: 16px 8px;
  }
}

.product-title {
  font-size: 14px;
  color: #000000;
  padding-bottom: 12px;
  text-align: center;
  height: 24px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}

.product-img {
  width: 100%;
  height: 160px;
  border-radius: 6px;
  
  @media (max-width: #{$breakpoint-lg}) {
    height: 140px;
  }
}

// 文本溢出处理
.line-one {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}

</style>
